'use strict';

var _preact = require('preact');

var _reactRedux = require('react-redux');

var _App = require('./components/App.jsx');

var _App2 = _interopRequireDefault(_App);

var _store = require('./store');

var _store2 = _interopRequireDefault(_store);

var _client = require('./client');

var _client2 = _interopRequireDefault(_client);

var _socket = require('./socket');

var _socket2 = _interopRequireDefault(_socket);

var _index = require('./actions/index.js');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_client2.default.folder.index().then(function (folders) {
  _store2.default.dispatch((0, _index.loadFolders)(folders));
  try {
    var openFolders = JSON.parse(localStorage['openFolders']);
    _store2.default.dispatch((0, _index.loadOpenFolders)(openFolders));
    openFolders.forEach(function (folder_id) {
      _client2.default.file.index({ folder_id: folder_id }).then(function (files) {
        _store2.default.dispatch((0, _index.loadFiles)(files));
      });
    });
  } catch (e) {
    console.log('error opening folders');
  }
});
_client2.default.task.index().then(function (tasks) {
  _store2.default.dispatch((0, _index.loadTasks)(tasks));
});

var app = (0, _preact.h)(
  _reactRedux.Provider,
  { store: _store2.default },
  (0, _preact.h)(_App2.default, null)
);

(0, _preact.render)(app, document.getElementById('container'));


//////////////////
// WEBPACK FOOTER
// ./client/index.jsx
// module id = 39
// module chunks = 0